import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { ViewComponent } from 'src/app/core/view/view.component';
import { SectorsService } from '../sectors.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sectors-detail',
  templateUrl: './sectors-detail.component.html',
  styleUrls: ['./sectors-detail.component.scss']
})
export class SectorsDetailComponent implements OnInit {

  @ViewChild("view") public view: ViewComponent;
  public sector: any = {};
  constructor(
    private sectorsService: SectorsService,

    private coreDialogService: CoreDialogService,
    private dynamicDialogRef: DynamicDialogRef,
    private messageService: MessageService,
    private config: DynamicDialogConfig,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.loadData(this.config.data.id);
  }
  loadData(id) {
    if (id) {
      this.sectorsService.get(id).subscribe({
        next: (data: any) => {
          this.sector = data;
        },
        error: (error: any) => {
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
        }
      });
    }
  }
  save(event: any) {
    if (!event.valid) {
      this.messageService.add({ closable: false, severity: "error", detail: this.translateService.instant("general.form_incomplete") });
      return;
    }
    if (typeof this.sector.id === "undefined") {
      this.sectorsService.add(this.sector).subscribe({
        next: (data: any) => {
          this.sector = data;
          this.loadData(this.sector.id);
          this.messageService.add({ closable: false, severity: 'success', summary: this.translateService.instant("component.sectors.detail.add_sector_correct") });
        },
        error: (error: any) => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      });
    } else {
      this.sectorsService.save(this.sector.id, this.sector).subscribe({
        next: (data: any) => {
          this.messageService.add({ closable: false, severity: "success", detail: this.translateService.instant("component.sectors.detail.save_sector_correct") });
          this.dynamicDialogRef.close();
        },
        error: (error: any) => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      });
    }
  }

  cancel() {
    this.dynamicDialogRef.close();
  }

  delete() {
    this.coreDialogService.confirm({
      message: this.translateService.instant("component.sectors.delete_message", { name: this.sector.name }),
      header: this.translateService.instant("general.confirmation_delete_title"),
      icon: "pi pi-info-circle",
      accept: () => {
        this.sectorsService.delete(this.sector.id).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: false, severity: 'success', detail: this.translateService.instant("general.confirmation_delete") });
            this.dynamicDialogRef.close();
          },
          error: (error: any) => {
            this.messageService.add({ closable: false, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: () => {
      }
    })
  }
  onEvent(event) {
    if (event.component == "sector.edit.general") {
      if (event.event == "action" && event.action.name == "delete") this.delete();
      if (event.event == "action" && event.action.name == "cancel") this.cancel();
      if (event.event == "action" && event.action.name == "save") this.save(event);
    }
  }
}
